import {
  useGetContractBalancesQuery,
  type ContractBalance,
} from 'src/graphql/generated';
import { getSite, getCountryFromSite } from 'src/utils/config';

import { useAccountContext } from '../operations/useAccountContext';

export const useHirerContracts = () => {
  const { data: accountContext } = useAccountContext();

  const site = getSite();
  const country = getCountryFromSite(site).toUpperCase();

  const waitingForAccountContext = !accountContext;

  const { loading, error, data } = useGetContractBalancesQuery({
    variables: {
      advertiserNation: country,
    },
  });

  return {
    // Force loading to come back as 'true' if we don't have the account info yet
    loading: waitingForAccountContext || loading,
    error,
    data: data?.contractBalances as ContractBalance[] | undefined,
  };
};
